<template>
  <div class="BankMKTComercial" v-loading="loadingPage">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <el-row :gutter="20">
        <el-col :lg="24" :md="24" :xs="24">
          <el-form-item prop="payment_method" label="Forma de recebimento">
            <el-select
              v-model="ruleForm.payment_method"
              @change="handleChangeFormPayment"
              clearable
              style="width: 100%"
            >
              <el-option label="Pix / TED" value="pix" />
              <el-option label="Conta Digital" value="deposit" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="ruleForm.payment_method != 'deposit'">
        <el-row :gutter="20">
          <el-col :lg="12" :md="12" :xs="24">
            <el-form-item prop="type" label="Tipo da Conta" :rules="[{required: true, message: 'Requerido', trigger: 'blur'}]">
              <el-select v-model="ruleForm.type" clearable style="width: 100%">
                <el-option label="Conta corrente" value="checking" />
                <el-option label="Conta Poupança" value="savings" />
                <el-option label="Conta de pagamentos de limite" value="payment" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="12" :xs="24">
            <el-form-item prop="bank_id" label="Banco" :rules="[{required: true, message: 'Requerido', trigger: 'blur'}]">
              <SelectSearchBanco :model="ruleForm.bank_id" :isEdit="false" @handleValue=" (x) => { ruleForm.bank_id = x } " />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="12" :xs="24">
            <el-form-item prop="routing_number" label="Nº da agência" :rules="[{required: true, message: 'Requerido', trigger: 'blur'}]">
              <el-input v-model="ruleForm.routing_number" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="12" :xs="24">
            <el-form-item prop="account_number" label="Nº da Conta (+ digito)" :rules="[{required: true, message: 'Requerido', trigger: 'blur'}]">
              <el-input v-model="ruleForm.account_number" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-divider></el-divider>
      <el-row :gutter="20">
        <el-col :lg="12" :md="12" :xs="24">
          <el-form-item prop="cpf" label="CPF do Titular">
            <el-input v-model="ruleForm.cpf" />
          </el-form-item>
        </el-col>
        <el-col v-if="ruleF.type_person === 'business'" :lg="12" :md="12" :xs="24">
          <el-form-item prop="cnpj" label="CNPJ do Titular">
            <el-input v-model="ruleForm.cnpj" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-divider></el-divider>
      <el-row :gutter="20">
        <el-col :lg="12" :md="12" :xs="24">
          <el-form-item prop="type_key_pix" label="Tipo de chave do PIX">
            <el-select v-model="ruleForm.type_key_pix" clearable style="width: 100%">
              <el-option label="E-mail" value="email" />
              <el-option label="Telefone" value="phone" />
              <el-option label="CPF" value="cpf" />
              <el-option label="CNPJ" value="cnpj" />
              <el-option label="Randômico" value="random" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12" :xs="24">
          <el-form-item prop="key_pix" label="Chave PIX">
            <el-input v-model="ruleForm.key_pix" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {getBankDados, postBankDados} from "@/app/domains/Records/services";
import SelectSearchBanco from "@/app/components/Banco/SelectSearchBanco";
import {clearRuleForm, getErrorFilds, makeErrorFilds} from "@/app/plugins/utils";

export default {
  name: "BankMKTComercial",
  data () {
    return {
      ruleForm: {
        person_id: '',
        bank_id: '',
        routing_number: '',
        account_number: '',
        type: '',
        cpf: '',
        cnpj: '',
        type_key_pix: '',
        key_pix: '',
      },
      updateForm: false,
      loadingPage: false,
    }
  },
  components: {
    SelectSearchBanco
  },
  props: ['ruleF'],
  watch: {
    ruleForm: {
      handler:  function (after, before) {
        this.updateForm = true
        this.$refs['ruleForm'].validate(async (valid, i) => {})
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.$refs['ruleForm'].validate(async (valid, i) => {
      if (valid && this.updateForm) {
        try {
          this.$set(this.ruleForm, 'person_id', this.ruleF.person_id)
          await postBankDados(clearRuleForm(this.ruleForm))
        } catch (e) {
          this.error = getErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        }
      }
    })
  },
  methods: {
    init () {
      this.getDados()
    },
    async getDados () {
      this.loadingPage = true
      try {
        let resp = (await getBankDados('?person_id='+ this.ruleF.person_id)).data.data
        let response = resp[(resp.length - 1)]

        if (response !== undefined) {

          if(response.bank.type_account == 'digital_account') {
            this.$set(this.ruleForm, 'payment_method', 'deposit');
          }else {
            this.$set(this.ruleForm, 'payment_method', 'pix');
          }
          
          this.$set(this.ruleForm, 'bank_id', response.bank_id)
          this.$set(this.ruleForm, 'routing_number', response.routing_number)
          this.$set(this.ruleForm, 'account_number', response.account_number)
          this.$set(this.ruleForm, 'type', response.type)
          this.$set(this.ruleForm, 'cpf', response.cpf)
          this.$set(this.ruleForm, 'cnpj', response.cnpj)
          this.$set(this.ruleForm, 'type_key_pix', response.type_key_pix)
          this.$set(this.ruleForm, 'key_pix', response.key_pix)
        }
        this.updateForm = false
      } catch (e) {
        this.error = getErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    handleChangeFormPayment() {
      if (this.ruleForm.payment_method === "deposit") {
        this.ruleForm.type = "checking";
        this.ruleForm.routing_number = "0001";
        this.ruleForm.account_number = "000010";
        this.ruleForm.bank_id = "293";
      } else {
        this.ruleForm.type = "";
        this.ruleForm.routing_number = "";
        this.ruleForm.account_number = "";
        this.ruleForm.bank_id = "";
      }
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
